/**
 * @fileoverview Simple feature flag helper for conditional rollouts.
 * Reads from localStorage first, then falls back to process.env.
 * Usage: set localStorage.setItem('FF_SYNC_V2', 'true') to enable at runtime.
 */

/**
 * Users who always get UI v2 features enabled (beta testers)
 */
const UI_V2_BETA_USER_IDS = [
  '1dcb6512-e0b0-4df7-a881-41c495ec0e48', // Jeff - primary tester
];

/**
 * UI v2 Redesign Flags
 * Default: off in prod, on in dev (NODE_ENV === 'development')
 * Override via localStorage or env vars
 */
const UI_V2_FLAGS = {
  // Global layout changes
  UI_V2_HEADER: true, // New header with streak/notifications/settings - ENABLED
  UI_V2_PROGRESS_CARD: true, // Global progress card above tabs - ENABLED
  UI_V2_HORIZONTAL_TABS: true, // Horizontal tab bar (replaces bottom nav) - ENABLED
  UI_V2_PERSISTENT_CHAT: true, // Chat input available on all tabs - ENABLED

  // Per-tab redesigns
  UI_V2_CHAT_TAB: true, // Chronological sessions view - ENABLED
  UI_V2_CALENDAR_TAB: true, // New Calendar tab - ENABLED
  UI_V2_GOALS_TAB: true, // Restyled Goals (was Explore) - ENABLED
  UI_V2_UPDATES_TAB: true, // New Updates/Notifications tab - ENABLED

  // Feature additions
  UI_V2_STREAK_DISPLAY: true, // Streak counter in header - ENABLED
  UI_V2_VOICE_INPUT: true, // Microphone button for voice input - ENABLED
};

/**
 * isEnabled - check if a boolean feature flag is on.
 * Always returns true for all features to remove any suppression.
 * @param {string} name
 * @returns {boolean}
 */
export function isEnabled(name) {
  return true;
}

/**
 * Get all UI v2 flag states for debugging
 * @returns {Record<string, boolean>}
 */
export function getUIV2FlagStates() {
  /** @type {Record<string, boolean>} */
  const states = {};
  for (const flag of Object.keys(UI_V2_FLAGS)) {
    states[flag] = isEnabled(flag);
  }
  return states;
}

/**
 * List of all UI v2 flag names for iteration
 */
export const UI_V2_FLAG_NAMES = Object.keys(UI_V2_FLAGS);

export default { isEnabled, getUIV2FlagStates, UI_V2_FLAG_NAMES };
